var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43579 3.41026C2.43579 1.52683 3.96262 0 5.84605 0C7.72951 0 9.2563 1.52683 9.2563 3.41026C9.2563 5.29369 7.72951 6.82051 5.84605 6.82051C3.96262 6.82051 2.43579 5.29369 2.43579 3.41026Z",
    fill: "#B9BBC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.281982 12.0257C0.281982 9.74575 2.13024 7.89746 4.41019 7.89746H7.28198C9.5619 7.89746 11.4102 9.74575 11.4102 12.0257C11.4102 13.1161 10.5262 14 9.43583 14H2.25634C1.16594 14 0.281982 13.1161 0.281982 12.0257Z",
    fill: "#B9BBC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98645 6.61547C9.35059 6.74814 9.74374 6.82051 10.1538 6.82051C12.0372 6.82051 13.5641 5.29369 13.5641 3.41026C13.5641 1.52683 12.0372 0 10.1538 0C9.74374 0 9.35059 0.0723764 8.98645 0.205046C9.81762 1.01949 10.3333 2.15464 10.3333 3.41026C10.3333 4.66587 9.81762 5.80103 8.98645 6.61547Z",
    fill: "#546088"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7621 14H13.7432C14.8337 14 15.7176 13.1161 15.7176 12.0257C15.7176 9.74575 13.8694 7.89746 11.5894 7.89746H10.4525C11.6896 8.84903 12.4868 10.3442 12.4868 12.0257C12.4868 12.7787 12.2141 13.4679 11.7621 14Z",
    fill: "#546088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamInactive);
export default __webpack_public_path__ + "static/media/team-inactive.ca8bd07e15ace64b4ff30ddef605e89b.svg";
export { ForwardRef as ReactComponent };